import PropTypes from 'prop-types';
import React from 'react';

/**
 * A component that displays an address suitable for a table cell.
 *
 * @param {Object} props - Address properties
 * @param {string} props.address1
 * @param {string} props.address2
 * @param {string} props.city
 * @param {string} props.state
 * @param {string} props.postalCode}
 */
const TableAddress = (props) => {
	if (props === undefined) {
		return (<span className='text-center'>--</span>);
	}
	const completeAddress = [props.address1, props.address2, props.city, props.state, props.postalCode].join('');

	if (completeAddress) {
		return (
			<div>
				<div>
					{props.address1}
					{' '}
					{props.address2}
				</div>
				<div>
					{props.city}
					{' '}
					{props.state}
					{' '}
					{props.postalCode}
				</div>
			</div>
		);
	}else{
		return (<span className='text-center'>--</span>); 
	}
};

TableAddress.propTypes = {
	address1: PropTypes.string.isRequired,
	address2: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired,
	state: PropTypes.string.isRequired,
	postalCode: PropTypes.string.isRequired
};

export default TableAddress;
